import { Department } from '@/domain/department'

import { RECOVERY_URL, RECOVERY_LABEL, REHABPATH_LABEL } from './constants'

interface FooterCopy {
  footerSiteLabel: string
  footerSiteURL: string
}

const FooterDepartmentMap = {
  [Department.MentalHealth]: {
    footerSiteLabel: RECOVERY_LABEL,
    footerSiteURL: RECOVERY_URL
  }
}

const DEFAULT_FOOTER_COPY: FooterCopy = {
  footerSiteLabel: REHABPATH_LABEL,
  footerSiteURL: RECOVERY_URL
}

export const getFooterSiteLabelURL = ({
  department
}: {
  department: Department
}): FooterCopy => {
  return FooterDepartmentMap[department] || DEFAULT_FOOTER_COPY
}
